var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "content" } },
    [
      _c("div", { staticClass: "header col-md-12" }, [
        _c("div", { staticClass: "header-inner row align-items-center" }, [
          _c("div", { staticClass: "col left" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("sidebar.paymententry")) +
                  " > " +
                  _vm._s(_vm.$t("sidebar.create")) +
                  "\n        "
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content col-md-12" },
        [
          !_vm.ready
            ? _c("p", [_vm._v(_vm._s(_vm.$t("message.loading")))])
            : _vm._e(),
          _vm._v(" "),
          _vm.ready
            ? [
                _c("section", [
                  _c(
                    "div",
                    { staticClass: "col-md-12 no-padding" },
                    [
                      _c("section-header", {
                        attrs: {
                          title: _vm.$t("message.typeofpaymententry"),
                          subtitle: _vm.$t("series.pe") + " " + _vm.nextPeCode
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row mt-3" }, [
                        _c("div", { staticClass: "col-md-6" }, [
                          _c(
                            "div",
                            { staticClass: "col-12 row no-margin no-padding" },
                            [
                              _c(
                                "vs-radio",
                                {
                                  staticStyle: { float: "left", padding: "0" },
                                  attrs: { color: "#A3CA76", vsValue: "pay" },
                                  model: {
                                    value: _vm.formType,
                                    callback: function($$v) {
                                      _vm.formType = $$v
                                    },
                                    expression: "formType"
                                  }
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(_vm.$t("message.checkboxexpense"))
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "form-check-label",
                              staticStyle: { "margin-left": "25px" }
                            },
                            [
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("message.checkboxexpensedetails")
                                  )
                                )
                              ])
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6" }, [
                          _c(
                            "div",
                            { staticClass: "col-12 row no-margin no-padding" },
                            [
                              _c(
                                "vs-radio",
                                {
                                  staticStyle: { float: "left", padding: "0" },
                                  attrs: {
                                    color: "#A3CA76",
                                    vsValue: "receive"
                                  },
                                  model: {
                                    value: _vm.formType,
                                    callback: function($$v) {
                                      _vm.formType = $$v
                                    },
                                    expression: "formType"
                                  }
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(_vm.$t("message.checkboxreceive"))
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "form-check-label",
                              staticStyle: { "margin-left": "25px" }
                            },
                            [
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("message.checkboxreceivedetails")
                                  )
                                )
                              ])
                            ]
                          )
                        ])
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("section", { staticClass: "mb-3" }, [
                  _c(
                    "div",
                    { staticClass: "col-md-12 no-padding" },
                    [
                      _c("section-header", {
                        attrs: { title: _vm.$t("message.reference") }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row" }, [
                        _c("div", { staticClass: "col-4" }, [
                          _c("label", [_vm._v(_vm._s(_vm.$t("message.type")))]),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.doc_type,
                                  expression: "form.doc_type"
                                }
                              ],
                              staticClass: "form-control custom-select",
                              class: [_vm.bindClass.doc_type],
                              on: {
                                change: function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    _vm.form,
                                    "doc_type",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                }
                              }
                            },
                            [
                              _c("option", { attrs: { value: "" } }, [
                                _vm._v(_vm._s(_vm.$t("placeholder.select")))
                              ]),
                              _vm._v(" "),
                              _vm.formType == "pay"
                                ? _c("option", { attrs: { value: "po" } }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("documents.po")) + " / PO-"
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.formType == "pay"
                                ? _c("option", { attrs: { value: "ex" } }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("documents.ex")) + " / EX-"
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.formType == "pay"
                                ? _c("option", { attrs: { value: "prl" } }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("documents.prl")) +
                                        " / PRL-"
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.formType == "receive"
                                ? _c("option", { attrs: { value: "in" } }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("documents.in")) + " / INV-"
                                    )
                                  ])
                                : _vm._e()
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _vm.form.doc_type != ""
                          ? _c(
                              "div",
                              {
                                staticClass: "col-8",
                                staticStyle: { position: "relative" }
                              },
                              [
                                _vm.loadingPO || _vm.loadingIN || _vm.loadingEX
                                  ? _c("i", {
                                      staticClass: "fas fa-spinner spin",
                                      staticStyle: {
                                        position: "absolute",
                                        top: "34px",
                                        right: "36px"
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                [
                                  _c("label", [
                                    _vm._v(_vm._s(_vm.$t("message.series")))
                                  ])
                                ],
                                _vm._v(" "),
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.form.doc_series,
                                        expression: "form.doc_series"
                                      }
                                    ],
                                    staticClass: "form-control custom-select",
                                    class: [_vm.bindClass.doc_series],
                                    attrs: {
                                      disabled:
                                        _vm.loadingPO ||
                                        _vm.loadingIN ||
                                        _vm.loadingEX
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.$set(
                                          _vm.form,
                                          "doc_series",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("option", { attrs: { value: "" } }, [
                                      _vm._v(
                                        _vm._s(_vm.$t("placeholder.select"))
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _vm.form.doc_type == "po"
                                      ? _vm._l(_vm.purchases, function(
                                          purchase,
                                          index
                                        ) {
                                          return _c(
                                            "option",
                                            {
                                              class: [
                                                {
                                                  "text-warning":
                                                    _vm.getPurchaseStatus(
                                                      purchase,
                                                      _vm.$t,
                                                      _vm.mixin
                                                    ).status == "padding",
                                                  "text-success":
                                                    _vm.getPurchaseStatus(
                                                      purchase,
                                                      _vm.$t,
                                                      _vm.mixin
                                                    ).status == "completed",
                                                  "text-info":
                                                    _vm.getPurchaseStatus(
                                                      purchase,
                                                      _vm.$t,
                                                      _vm.mixin
                                                    ).status == "uncompleted",
                                                  "text-danger":
                                                    _vm.getPurchaseStatus(
                                                      purchase,
                                                      _vm.$t,
                                                      _vm.mixin
                                                    ).status == "rejected"
                                                }
                                              ],
                                              attrs: {
                                                disabled:
                                                  purchase.status != "approved"
                                              },
                                              domProps: {
                                                value: purchase.po_id
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(purchase.po_code) +
                                                  "\n                    (" +
                                                  _vm._s(
                                                    _vm.getPurchaseStatus(
                                                      purchase,
                                                      _vm.$t,
                                                      _vm.mixin
                                                    ).message
                                                  ) +
                                                  ")\n                  "
                                              )
                                            ]
                                          )
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.form.doc_type == "ex"
                                      ? _vm._l(_vm.expenses, function(
                                          expense,
                                          index
                                        ) {
                                          return _c(
                                            "option",
                                            {
                                              class: [
                                                {
                                                  "text-warning":
                                                    _vm.getExpenseStatus(
                                                      expense,
                                                      _vm.$t,
                                                      _vm.mixin
                                                    ).status == "padding",
                                                  "text-success":
                                                    _vm.getExpenseStatus(
                                                      expense,
                                                      _vm.$t,
                                                      _vm.mixin
                                                    ).status == "completed",
                                                  "text-info":
                                                    _vm.getExpenseStatus(
                                                      expense,
                                                      _vm.$t,
                                                      _vm.mixin
                                                    ).status == "uncompleted",
                                                  "text-danger":
                                                    _vm.getExpenseStatus(
                                                      expense,
                                                      _vm.$t,
                                                      _vm.mixin
                                                    ).status == "rejected"
                                                }
                                              ],
                                              attrs: {
                                                disabled:
                                                  expense.status != "approved"
                                              },
                                              domProps: { value: expense.ex_id }
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(expense.ex_code) +
                                                  "\n                    (" +
                                                  _vm._s(
                                                    _vm.getExpenseStatus(
                                                      expense,
                                                      _vm.$t,
                                                      _vm.mixin
                                                    ).message
                                                  ) +
                                                  ")\n                  "
                                              )
                                            ]
                                          )
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.form.doc_type == "in"
                                      ? _vm._l(_vm.invoices, function(
                                          invoice,
                                          index
                                        ) {
                                          return _c(
                                            "option",
                                            {
                                              class: [
                                                {
                                                  "text-warning":
                                                    _vm.getInvoiceStatus(
                                                      invoice,
                                                      _vm.$t,
                                                      _vm.mixin
                                                    ).status == "padding",
                                                  "text-success":
                                                    _vm.getInvoiceStatus(
                                                      invoice,
                                                      _vm.$t,
                                                      _vm.mixin
                                                    ).status == "completed",
                                                  "text-info":
                                                    _vm.getInvoiceStatus(
                                                      invoice,
                                                      _vm.$t,
                                                      _vm.mixin
                                                    ).status == "uncompleted",
                                                  "text-danger":
                                                    _vm.getInvoiceStatus(
                                                      invoice,
                                                      _vm.$t,
                                                      _vm.mixin
                                                    ).status == "rejected"
                                                }
                                              ],
                                              attrs: {
                                                disabled:
                                                  invoice.status != "approved"
                                              },
                                              domProps: { value: invoice.in_id }
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(invoice.in_code) +
                                                  "\n                    (" +
                                                  _vm._s(
                                                    _vm.getInvoiceStatus(
                                                      invoice,
                                                      _vm.$t,
                                                      _vm.mixin
                                                    ).message
                                                  ) +
                                                  ")\n                  "
                                              )
                                            ]
                                          )
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.form.doc_type == "prl"
                                      ? _vm._l(_vm.paySlipList, function(
                                          item,
                                          index
                                        ) {
                                          return _c(
                                            "option",
                                            {
                                              class: [
                                                {
                                                  "text-warning":
                                                    item.process.status ==
                                                    "pending",
                                                  "text-success":
                                                    item.process.status ==
                                                    "completed",
                                                  "text-info":
                                                    item.process.status ==
                                                    "uncompleted",
                                                  "text-danger":
                                                    item.process.status ==
                                                    "rejected"
                                                }
                                              ],
                                              attrs: {
                                                disabled:
                                                  item.status != "approved"
                                              },
                                              domProps: { value: item.prlId }
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(item.prlCode) +
                                                  "\n                    "
                                              ),
                                              _c("BaseDocumentProcessStatus", {
                                                attrs: {
                                                  docType: "prl",
                                                  status: item.process.status
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        })
                                      : _vm._e()
                                  ],
                                  2
                                )
                              ],
                              2
                            )
                          : _vm._e()
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _vm.form.doc_type != "" && _vm.form.doc_series != ""
                  ? _c("section", { staticClass: "mb-3" }, [
                      _c(
                        "div",
                        { staticClass: "col-md-12 no-padding" },
                        [
                          _c("section-header", {
                            attrs: { title: _vm.sectionHeaderRefCode }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "form-row mt-2" },
                            [
                              [
                                _vm.partnerInfo.vendor !== undefined
                                  ? _c("div", { staticClass: "col-4" }, [
                                      _c("label", [
                                        _vm._v(_vm._s(_vm.$t("message.vendor")))
                                      ]),
                                      _vm._v(" "),
                                      _c("input", {
                                        staticClass: "form-control",
                                        attrs: { disabled: true, type: "text" },
                                        domProps: {
                                          value: _vm.partnerInfo.vendor
                                            ? _vm.partnerInfo.vendor.vendor_name
                                            : ""
                                        }
                                      })
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.partnerInfo.customer !== undefined
                                  ? _c("div", { staticClass: "col-4" }, [
                                      _c("label", [
                                        _vm._v(
                                          _vm._s(_vm.$t("message.customer"))
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("input", {
                                        staticClass: "form-control",
                                        attrs: { disabled: true, type: "text" },
                                        domProps: {
                                          value: _vm.partnerInfo.customer
                                            ? _vm.partnerInfo.customer
                                                .customer_name
                                            : ""
                                        }
                                      })
                                    ])
                                  : _vm._e()
                              ],
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-4" },
                                [
                                  _c("label", [
                                    _vm._v(_vm._s(_vm.$t("message.debttotal")))
                                  ]),
                                  _vm._v(" "),
                                  [
                                    _vm.docInfo.po
                                      ? _c("input", {
                                          staticClass: "form-control text-info",
                                          attrs: {
                                            disabled: true,
                                            type: "text"
                                          },
                                          domProps: {
                                            value: _vm.setToCustomDigitsNumber(
                                              _vm.getDebtPurchaseAmount(
                                                _vm.docInfo.po
                                              )
                                            )
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.docInfo.in
                                      ? _c("input", {
                                          staticClass: "form-control text-info",
                                          attrs: {
                                            disabled: true,
                                            type: "text"
                                          },
                                          domProps: {
                                            value: _vm.setToCustomDigitsNumber(
                                              _vm.getDebtInvoiceAmount(
                                                _vm.docInfo.in
                                              )
                                            )
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.docInfo.ex
                                      ? _c("input", {
                                          staticClass: "form-control text-info",
                                          attrs: {
                                            disabled: true,
                                            type: "text"
                                          },
                                          domProps: {
                                            value: _vm.setToCustomDigitsNumber(
                                              _vm.getDebtExpenseAmount(
                                                _vm.docInfo.ex
                                              )
                                            )
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.docInfo.prl
                                      ? _c("input", {
                                          staticClass: "form-control text-info",
                                          attrs: {
                                            disabled: true,
                                            type: "text"
                                          },
                                          domProps: {
                                            value: _vm.setToCustomDigitsNumber(
                                              _vm.getDebtPayslipAmount(
                                                _vm.docInfo.prl
                                              )
                                            )
                                          }
                                        })
                                      : _vm._e()
                                  ]
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  class: {
                                    "col-md-2":
                                      !_vm.docInfo.ex || !_vm.docInfo.prl,
                                    "col-md-4":
                                      _vm.docInfo.ex || _vm.docInfo.prl
                                  }
                                },
                                [
                                  _c("label", [
                                    _vm._v(_vm._s(_vm.$t("message.paidtotal")))
                                  ]),
                                  _vm._v(" "),
                                  [
                                    _vm.docInfo.po
                                      ? _c("input", {
                                          staticClass: "form-control",
                                          attrs: {
                                            disabled: true,
                                            type: "text"
                                          },
                                          domProps: {
                                            value: _vm.setToCustomDigitsNumber(
                                              _vm.getPaidAmount(
                                                _vm.docInfo.po.reference
                                                  .payments
                                              )
                                            )
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.docInfo.in
                                      ? _c("input", {
                                          staticClass: "form-control",
                                          attrs: {
                                            disabled: true,
                                            type: "text"
                                          },
                                          domProps: {
                                            value: _vm.setToCustomDigitsNumber(
                                              _vm.getPaidAmount(
                                                _vm.docInfo.in.reference
                                                  .payments
                                              )
                                            )
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.docInfo.ex
                                      ? _c("input", {
                                          staticClass: "form-control",
                                          attrs: {
                                            disabled: true,
                                            type: "text"
                                          },
                                          domProps: {
                                            value: _vm.setToCustomDigitsNumber(
                                              _vm.getPaidAmount(
                                                _vm.docInfo.ex.reference
                                                  .payments
                                              )
                                            )
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.docInfo.prl
                                      ? _c("input", {
                                          staticClass: "form-control",
                                          attrs: {
                                            disabled: true,
                                            type: "text"
                                          },
                                          domProps: {
                                            value: _vm.setToCustomDigitsNumber(
                                              _vm.docInfo.prl.net -
                                                _vm.docInfo.prl.process.debit
                                            )
                                          }
                                        })
                                      : _vm._e()
                                  ]
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  class: {
                                    "col-md-2":
                                      !_vm.docInfo.ex || !_vm.docInfo.prl,
                                    "col-md-4":
                                      _vm.docInfo.ex || _vm.docInfo.prl
                                  }
                                },
                                [
                                  _c("label", [
                                    _vm._v(_vm._s(_vm.$t("message.grandtotal")))
                                  ]),
                                  _vm._v(" "),
                                  [
                                    _vm.docInfo.po
                                      ? _c("input", {
                                          staticClass: "form-control",
                                          attrs: {
                                            disabled: true,
                                            type: "text"
                                          },
                                          domProps: {
                                            value: _vm.setToCustomDigitsNumber(
                                              _vm.getTotal(
                                                _vm.docInfo.po.orders
                                              ).payment
                                            )
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.docInfo.in
                                      ? _c("input", {
                                          staticClass: "form-control",
                                          attrs: {
                                            disabled: true,
                                            type: "text"
                                          },
                                          domProps: {
                                            value: _vm.setToCustomDigitsNumber(
                                              _vm.getTotal(
                                                _vm.docInfo.in.orders
                                              ).payment
                                            )
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.docInfo.ex
                                      ? _c("input", {
                                          staticClass: "form-control",
                                          attrs: {
                                            disabled: true,
                                            type: "text"
                                          },
                                          domProps: {
                                            value: _vm.setToCustomDigitsNumber(
                                              _vm.docInfo.ex.payment.amount
                                            )
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.docInfo.prl
                                      ? _c("input", {
                                          staticClass: "form-control",
                                          attrs: {
                                            disabled: true,
                                            type: "text"
                                          },
                                          domProps: {
                                            value: _vm.setToCustomDigitsNumber(
                                              _vm.docInfo.prl.net
                                            )
                                          }
                                        })
                                      : _vm._e()
                                  ]
                                ],
                                2
                              )
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("section", [
                  _c(
                    "div",
                    { staticClass: "col-md-12 no-padding" },
                    [
                      _c("section-header", {
                        attrs: { title: _vm.$t("message.infopayment") }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row mb-2" }, [
                        _c("div", { staticClass: "col-md-4" }, [
                          _c("label", [_vm._v(_vm._s(_vm.$t("message.type")))]),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.payment_type,
                                  expression: "form.payment_type"
                                }
                              ],
                              staticClass: "form-control custom-select",
                              on: {
                                change: function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    _vm.form,
                                    "payment_type",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                }
                              }
                            },
                            [
                              _c("option", { attrs: { value: "cash" } }, [
                                _vm._v(_vm._s(_vm.$t("message.cash")))
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "card" } }, [
                                _vm._v(_vm._s(_vm.$t("message.creditcard")))
                              ])
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-4" }, [
                          _c("label", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("message.paidamount", {
                                  string: _vm.currency
                                })
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.form.payment_amount,
                                expression: "form.payment_amount"
                              }
                            ],
                            staticClass:
                              "form-control number-only text-select-all",
                            class: [_vm.bindClass.payment_amount],
                            attrs: { type: "text" },
                            domProps: { value: _vm.form.payment_amount },
                            on: {
                              keypress: _vm.numberOnly,
                              keyup: function($event) {
                                _vm.form.payment_amount = _vm.setToValidNumber(
                                  _vm.form.payment_amount
                                )
                              },
                              blur: function($event) {
                                _vm.form.payment_amount = _vm.setToCustomDigitsNumber(
                                  _vm.form.payment_amount
                                )
                              },
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.form,
                                  "payment_amount",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-md-4" },
                          [
                            _c("label", [
                              _vm._v(_vm._s(_vm.$t("message.postingpaiddate")))
                            ]),
                            _vm._v(" "),
                            _c("BaseInputDatePicker", {
                              model: {
                                value: _vm.form.payment_date,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "payment_date", $$v)
                                },
                                expression: "form.payment_date"
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row mb-3" }, [
                        _c("div", { staticClass: "col-12" }, [
                          _c("label", [_vm._v(_vm._s(_vm.$t("message.note")))]),
                          _vm._v(" "),
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.form.note,
                                expression: "form.note"
                              }
                            ],
                            staticClass: "form-control form-control-sm",
                            staticStyle: { "min-height": "90px" },
                            attrs: {
                              placeholder: _vm.$t("placeholder.dotted")
                            },
                            domProps: { value: _vm.form.note },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(_vm.form, "note", $event.target.value)
                              }
                            }
                          })
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row" }, [
                        _c(
                          "div",
                          { staticClass: "col-12" },
                          [
                            _c(
                              "vs-checkbox",
                              {
                                staticStyle: {
                                  float: "left",
                                  position: "relative",
                                  top: "0",
                                  left: "-5px"
                                },
                                attrs: { color: "#A3CA76" },
                                model: {
                                  value: _vm.form.ispaid,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "ispaid", $$v)
                                  },
                                  expression: "form.ispaid"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("message.ispaid")) +
                                    "\n              "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "section",
                  { staticClass: "action-bar" },
                  [
                    [
                      !_vm.$store.state.app.loading || !_vm.isReadyToSave
                        ? _c("div", { staticClass: "col-md-12 text-right" }, [
                            _c("div", { staticClass: "btn-group" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-web",
                                  attrs: {
                                    disabled: !_vm.isReadyToSave,
                                    type: "button"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.save({
                                        isCreateAnother: false
                                      })
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("button.save")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-web dropdown-toggle dropdown-toggle-split",
                                  attrs: {
                                    disabled: !_vm.isReadyToSave,
                                    type: "button",
                                    "data-toggle": "dropdown",
                                    "aria-haspopup": "true",
                                    "aria-expanded": "false"
                                  }
                                },
                                [
                                  _c("span", { staticClass: "sr-only" }, [
                                    _vm._v("Toggle Dropdown")
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "dropdown-menu dropdown-menu-right"
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      on: {
                                        click: function($event) {
                                          return _vm.save({
                                            isCreateAnother: true
                                          })
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("button.saveandcreateanother")
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.$store.state.app.loading && _vm.isReadyToSave
                        ? _c("div", { staticClass: "col-md-12 text-right" }, [
                            _vm._m(0)
                          ])
                        : _vm._e()
                    ]
                  ],
                  2
                )
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("BaseConfirmDiscardModal", {
        attrs: { show: _vm.confirmDiscardModal.show },
        on: {
          onCancel: _vm.handleDiscardCancleModal,
          onConfirm: _vm.handleDiscardConfirmModal
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "btn-group" }, [
      _c(
        "button",
        { staticClass: "btn btn-web", attrs: { type: "button", disabled: "" } },
        [_c("i", { staticClass: "fas fa-spinner spin" })]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-web dropdown-toggle dropdown-toggle-split",
          attrs: {
            type: "button",
            "data-toggle": "dropdown",
            "aria-haspopup": "true",
            "aria-expanded": "false",
            disabled: ""
          }
        },
        [_c("span", { staticClass: "sr-only" }, [_vm._v("Toggle Dropdown")])]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "dropdown-menu" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bc5eab4e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bc5eab4e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/accounts/paymententry/New.vue
// module id = null
// module chunks = 